import listSaga from './listSaga'
import oneMeetingSaga from './oneMeetingSaga'

const meetingAgendaSaga = [listSaga(), oneMeetingSaga()]

export default meetingAgendaSaga
